import assetActionTypeService from "../../../../services/assetService/assetActionService/assetActionTypeService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETACTIONTYPES } from "../../../../utils/constants";
import { AssetActionTypeInterface } from "../../../../models/AssetModel/AssetAction/AssetActionType";

interface DeleteAssetActionTypeContext {
  previousAssetActiontypes: AssetActionTypeInterface[];
  deletedAssetActionType: AssetActionTypeInterface | undefined;
}

const useDeleteAssetActionType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the category to delete
    DeleteAssetActionTypeContext
  >({
    mutationFn: assetActionTypeService.Remove, // Remove should take a string ID

    onMutate: (assetActionTypeId: string) => {
      const previousAssetActiontypes =
        queryClient.getQueryData<AssetActionTypeInterface[]>([
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetActionTypeInterface[]>(
        [
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        previousAssetActiontypes.filter(
          (assetActionType) => assetActionType.id !== assetActionTypeId
        ) // Use assetActionTypeId to filter
      );

      return {
        previousAssetActiontypes,
        deletedAssetActionType: previousAssetActiontypes.find(
          (assetActionType) => assetActionType.id === assetActionTypeId
        ),
      };
    },

    onError: (error, assetActionTypeId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetActionTypeInterface[]>(
        [
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetActiontypes
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAssetActionType;
